
    import { mount } from "svelte";
    import App from './Notepad2.svelte'
    import '../base.css'
    const args = {
      target: document.getElementById("app"),
    };
    const app = mount(App, args);
  